module.exports = __webpack_public_path__ + "img/flow2.a21fe2b2.png";